(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoController', AlumnoUadyMatriculadoController);

    AlumnoUadyMatriculadoController.$inject = ['AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoController(AlumnoUadyMatriculado) {

        var vm = this;

        vm.alumnoUadyMatriculados = [];

        loadAll();

        function loadAll() {
            AlumnoUadyMatriculado.query(function(result) {
                vm.alumnoUadyMatriculados = result;
                vm.searchQuery = null;
            });
        }
    }
})();
